<template>
	<div>
		<b-form-file
			:ref="'fileset_file_' + id"
			accept=".csv"
			@change="addTabulator"
			placeholder="Importer un csv pour édition"></b-form-file>

		<b-form-input v-model="value" @change="updatePage"></b-form-input>

		<div :id="'builder' + id"></div>

		<b-button @click="reset">Reset</b-button>&nbsp;
		<b-button v-b-modal="'modal' + id"><i class="fas fa-eye"></i></b-button>

		<b-modal :hide-footer="true" :id="'modal' + id" title="Requête">
			<p>{{ request }}</p>
		</b-modal>

	<div ref="tabulator" class="table-striped"></div>

		<b-container>
			<b-row>
				<b-col class="form-inline">
					<b-button @click="dowloadCSV"
						><i class="fas fa-file-download"></i> csv</b-button
					>
					&nbsp;
					<b-button @click="dowloadExcel"
						><i class="fas fa-file-download"></i> xlsx</b-button
					>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	const chardet = require("chardet");

	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import alasql from "alasql";
	import * as CSV from "csv-string";
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "fileset",
		data: function () {
			return {
				tabulator: null,

				data: [],
				dowload: true,
				tabulator_options: {
					columns: [],
				},
				tabulator_data: [],
				rules: "",
				rules_sql: "",
				request: "",
				value: "",
				id: uniqueId(""),
			};
		},
		watch: {
			tabulator_data: {
				deep: true,
				handler(newData) {
					//console.log("watch tabulator_data")
					this.$emit("update", this.tabulator_data);
					if (this.tabulator && newData && this.tabulatorReady) {
						this.tabulator.replaceData(newData);
					}
				},
			},
		},
		mounted: async function () {
			console.log("[FILESET] mounted, id:", this.id);
			var self = this;
			
			this.tabulator_options = {
				columns: [],
				paginationSize: 10,
				pagination: "local",
				//columnMaxWidth: 500,
				tooltips: true, //show tool tips on cells
				addRowPos: "top", //when adding a new row, add it to the top of the table
				history: true, //allow undo and redo actions on the table
				movableColumns: true, //allow column order to be changed
				resizableRows: true, //allow row order to be changed
				data: this.tabulator_data,
				selectable: true,
				nestedFieldSeparator: false,
				// Tabulator 6 : downloadReady est remplacé par downloadEncoder
				downloadEncoder: function (fileContents, mimeType) {
					console.log("[FILESET] downloadEncoder callback called");
					var blob = new Blob([fileContents], {type: mimeType});
					self.tabulator_data_csv = blob;
					if (self.dowload == false) {
						if (self.resolve) self.resolve();
						return false; // abort download
					} else {
						self.dowload = false;
						return blob;
					}
				},
			};

			// Créer l'instance Tabulator
			this.$nextTick(() => {
				console.log("[FILESET] $nextTick, ref exists:", !!this.$refs.tabulator, "columns:", this.tabulator_options.columns.length);
				if (this.$refs.tabulator) {
					this.tabulator = new Tabulator(this.$refs.tabulator, this.tabulator_options);
					console.log("[FILESET] Tabulator instance created");
					
					// Avec Tabulator 6, utiliser .on() pour les événements
					this.tabulator.on("tableBuilt", function() {
						self.tabulatorReady = true;
						console.log("[FILESET] tableBuilt event fired");
					});
					
					/*this.tabulator.on("renderComplete", function() {
						console.log("[FILESET] renderComplete event fired");
						if (!self.tabulatorReady) {
							self.tabulatorReady = true;
						}
					});*/
				}
			});
		},
		methods: {
			save() {
				return {
					data: this.data,
					rules: this.rules,
					value: this.value,
					columns: this.tabulator_options.columns,
				};
			},
			async load(data) {
				console.log("[FILESET] load() called with data rows:", data.data?.length, "columns:", data.columns?.length, "tabulator exists:", !!this.tabulator, "tabulatorReady:", this.tabulatorReady);
				this.tabulator_options.columns = data.columns;
				this.data = data.data;
				this.value = data.value;
				this.tabulator_data = data.data;

				// Attendre que le Tabulator soit prêt (qu'il existe ET soit initialisé)
				if (!this.tabulator || !this.tabulatorReady) {
					console.log("[FILESET] Waiting for tabulator to be ready...");
					var c = true;
					while (c)
					{
						await new Promise(resolve => setTimeout(resolve, 50));
						if (this.tabulator && this.tabulatorReady) {
							c = false;
							console.log("[FILESET] Tabulator is now ready!");
						}
						else
						{
							//console.log("[FILESET] Tabulator is not ready.");
						}
					}
				}

				console.log("[FILESET] load() : tabulator ready");

				// Mettre à jour le Tabulator existant avec les nouvelles colonnes et données
				if (this.tabulator && this.tabulatorReady) {
					console.log("[FILESET] Updating tabulator with setColumns and replaceData");
					this.tabulator.setColumns(data.columns);
					this.tabulator.replaceData(data.data);
				}

				try {
					this.setBuilder(Object.keys(this.data[0]));
					if (data.rules && data.rules !== "") {
						$("#builder" + this.id).queryBuilder(
							"setRules",
							data.rules
						);
					}
					await this.updatePage();
				} catch (err) {
					console.log("[FILESET] Error in load:", err);
					// En cas d'erreur, s'assurer que les données sont bien dans le Tabulator
					this.tabulator_data = data.data;
					if (this.tabulator && this.tabulatorReady) {
						this.tabulator.replaceData(data.data);
					}
				}
			},
			dowloadCSV: function () {
				this.dowload = true;
				this.tabulator.download("csv", "data.csv");
			},
			dowloadExcel: function () {
				this.dowload = true;
				this.tabulator.download("xlsx", "data.xlsx");
			},
			get_data() {
				return tabulator_data;
			},
			setBuilder(columns) {
				var self = this;
				var id = this.id;

				var columns_query_builder = [];
				for (var i = 0; i < columns.length; i++) {
					columns_query_builder.push({
						id: "`" + columns[i] + "`",
						label: columns[i],
						type: "string",
					});
				}

				var config = {
					filters: columns_query_builder,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				$("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							self.rules = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							//self.rules = $('#builder').queryBuilder('getRules');
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_sql = " " + $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);
			},
			addTabulator: async function (event = null) {
				console.log("[FILESET] addTabulator called", event);
				var self = this;
				var id = this.id;

				var file = null;
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];
				this.name_file_tabulator = file.name;
				var str = await file.arrayBuffer();
				var encoding = chardet.detect(Buffer.from(str));
				var str = new TextDecoder().decode(str);
				var separator = CSV.detect(str);
				if (separator != "," && separator != ";" && separator != "\t")
					separator = ",";
				this.$papa.parse(file, {
					encoding: encoding,
					delimiter: separator,
					header: true,
					skipEmptyLines: true,
					complete: function (results) {
						console.log("[FILESET] CSV parsed, rows:", results.data.length, "fields:", results.meta.fields.length);
						self.tabulator_data = results.data;
						self.data = results.data;
						var fields = results.meta.fields;
						var columns = [];
						for (var i = 0; i < fields.length; i++) {
							columns.push({
								title: fields[i],
								field: fields[i],
								editor: "textarea",
								headerContextMenu: this.headerContextMenu,
							});
						}
						self.tabulator_options.columns = columns;
						console.log("[FILESET] Columns set, count:", columns.length, "tabulator exists:", !!self.tabulator);

						// Mettre à jour le Tabulator existant avec les nouvelles colonnes et données
						if (self.tabulator) {
							console.log("[FILESET] Updating existing tabulator with setColumns and replaceData");
							self.tabulator.setColumns(columns);
							self.tabulator.replaceData(self.tabulator_data);
						}

						try {
							$("#builder" + id).queryBuilder("destroy");
						} catch (err) {}

						self.setBuilder(fields);
						self.$refs["fileset_file_" + self.id].reset();
					},
				});
			},
			reset() {
				$("#builder" + this.id).queryBuilder("reset");
				this.rules_sql = "";
				this.updatePage();
			},
			async updatePage(event = null) {
				var pagination_size = 10;

				this.request = "";
				if (this.rules_sql) this.request = " WHERE " + this.rules_sql;
				if (this.value) this.request += " " + this.value;

				if (this.request)
					this.tabulator_data = alasql(
						"SELECT * FROM ? " + this.request,
						[this.data]
					);
				else this.tabulator_data = this.data;
			},
		},
	};
</script>
